import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { Spinner, Container } from 'react-bootstrap';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  const returnTo = encodeURIComponent(location.pathname + location.search);

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (!currentUser) {
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  // Check if email is verified for email/password users
  // Social login users (Google, GitHub) are automatically verified
  const isEmailPasswordUser = currentUser.providerData.some(
    provider => provider.providerId === 'password'
  );

  if (isEmailPasswordUser && !currentUser.emailVerified) {
    return <Navigate to={`/verify-email?returnTo=${returnTo}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
